export const redactUrlForTelemetry = (value) => {
  if (value === undefined || value === null) return value;
  return String(value).split('#', 1)[0];
};
